
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexX4MjoTF96yMeta } from "/app/template1/pages/(discover)/[categorySlug]/index.vue?macro=true";
import { default as _91productSlug_93ILWZhq2CPcMeta } from "/app/template1/pages/(discover)/experiences/[productSlug].vue?macro=true";
import { default as indexWpgAN0DOyaMeta } from "/app/template1/pages/(discover)/experiences/index.vue?macro=true";
import { default as _91productSlug_93igb0ZHyBqRMeta } from "/app/template1/pages/(discover)/things-to-do-in-[slug]/[productSlug].vue?macro=true";
import { default as indexdDoM7YEgHcMeta } from "/app/template1/pages/(discover)/things-to-do-in-[slug]/index.vue?macro=true";
import { default as aboutD0lvAVjA6AMeta } from "/app/template1/pages/about.vue?macro=true";
import { default as reset_45password4Ee8363TyfMeta } from "/app/template1/pages/auth/reset-password.vue?macro=true";
import { default as _91slug_93id6Yi1S4fMMeta } from "/app/template1/pages/blog/[slug].vue?macro=true";
import { default as indexMZOEeJmcdAMeta } from "/app/template1/pages/blog/index.vue?macro=true";
import { default as index2caqQ0w6V5Meta } from "/app/template1/pages/cart/index.vue?macro=true";
import { default as error465m77tB0CMeta } from "/app/template1/pages/checkout/error.vue?macro=true";
import { default as indexZUIhXWpEEhMeta } from "/app/template1/pages/checkout/index.vue?macro=true";
import { default as on_holdJuvXWHRQxdMeta } from "/app/template1/pages/checkout/on_hold.vue?macro=true";
import { default as successHqA0ANDucJMeta } from "/app/template1/pages/checkout/success.vue?macro=true";
import { default as coming_45soonqUDf7WZmNUMeta } from "/app/template1/pages/coming-soon.vue?macro=true";
import { default as contact_45usUPHuMLpWIsMeta } from "/app/template1/pages/contact-us.vue?macro=true";
import { default as faqIi9s2t9CGkMeta } from "/app/template1/pages/faq.vue?macro=true";
import { default as indexZJmw54qGOdMeta } from "/app/template1/pages/index.vue?macro=true";
import { default as indexu7Cj31XlOkMeta } from "/app/template1/pages/invoices/index.vue?macro=true";
import { default as privacy_45policy5oIXqcV7hoMeta } from "/app/template1/pages/privacy-policy.vue?macro=true";
import { default as index2cc3MYIpo2Meta } from "/app/template1/pages/search/[searchText]/index.vue?macro=true";
import { default as terms_45and_45conditionsfF8jNvHf6GMeta } from "/app/template1/pages/terms-and-conditions.vue?macro=true";
import { default as component_45stubjXzIzd4uHTMeta } from "/app/template1/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubjXzIzd4uHT } from "/app/template1/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "categorySlug___es",
    path: "/es/:categorySlug()",
    component: () => import("/app/template1/pages/(discover)/[categorySlug]/index.vue")
  },
  {
    name: "categorySlug___en",
    path: "/:categorySlug()",
    component: () => import("/app/template1/pages/(discover)/[categorySlug]/index.vue")
  },
  {
    name: "experiences-productSlug___es",
    path: "/es/experiences/:productSlug()",
    component: () => import("/app/template1/pages/(discover)/experiences/[productSlug].vue")
  },
  {
    name: "experiences-productSlug___en",
    path: "/experiences/:productSlug()",
    component: () => import("/app/template1/pages/(discover)/experiences/[productSlug].vue")
  },
  {
    name: "experiences___es",
    path: "/es/experiences",
    component: () => import("/app/template1/pages/(discover)/experiences/index.vue")
  },
  {
    name: "experiences___en",
    path: "/experiences",
    component: () => import("/app/template1/pages/(discover)/experiences/index.vue")
  },
  {
    name: "things-to-do-in-slug-productSlug___es",
    path: "/es/things-to-do-in-:slug()/:productSlug()",
    component: () => import("/app/template1/pages/(discover)/things-to-do-in-[slug]/[productSlug].vue")
  },
  {
    name: "things-to-do-in-slug-productSlug___en",
    path: "/things-to-do-in-:slug()/:productSlug()",
    component: () => import("/app/template1/pages/(discover)/things-to-do-in-[slug]/[productSlug].vue")
  },
  {
    name: "things-to-do-in-slug___es",
    path: "/es/things-to-do-in-:slug()",
    component: () => import("/app/template1/pages/(discover)/things-to-do-in-[slug]/index.vue")
  },
  {
    name: "things-to-do-in-slug___en",
    path: "/things-to-do-in-:slug()",
    component: () => import("/app/template1/pages/(discover)/things-to-do-in-[slug]/index.vue")
  },
  {
    name: "about___es",
    path: "/es/about",
    component: () => import("/app/template1/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/about",
    component: () => import("/app/template1/pages/about.vue")
  },
  {
    name: "auth-reset-password___es",
    path: "/es/auth/reset-password",
    component: () => import("/app/template1/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___en",
    path: "/auth/reset-password",
    component: () => import("/app/template1/pages/auth/reset-password.vue")
  },
  {
    name: "blog-slug___es",
    path: "/es/blog/:slug()",
    component: () => import("/app/template1/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___en",
    path: "/blog/:slug()",
    component: () => import("/app/template1/pages/blog/[slug].vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    component: () => import("/app/template1/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/app/template1/pages/blog/index.vue")
  },
  {
    name: "cart___es",
    path: "/es/cart",
    component: () => import("/app/template1/pages/cart/index.vue")
  },
  {
    name: "cart___en",
    path: "/cart",
    component: () => import("/app/template1/pages/cart/index.vue")
  },
  {
    name: "checkout-error___es",
    path: "/es/checkout/error",
    component: () => import("/app/template1/pages/checkout/error.vue")
  },
  {
    name: "checkout-error___en",
    path: "/checkout/error",
    component: () => import("/app/template1/pages/checkout/error.vue")
  },
  {
    name: "checkout___es",
    path: "/es/checkout",
    component: () => import("/app/template1/pages/checkout/index.vue")
  },
  {
    name: "checkout___en",
    path: "/checkout",
    component: () => import("/app/template1/pages/checkout/index.vue")
  },
  {
    name: "checkout-on_hold___es",
    path: "/es/checkout/on_hold",
    component: () => import("/app/template1/pages/checkout/on_hold.vue")
  },
  {
    name: "checkout-on_hold___en",
    path: "/checkout/on_hold",
    component: () => import("/app/template1/pages/checkout/on_hold.vue")
  },
  {
    name: "checkout-success___es",
    path: "/es/checkout/success",
    component: () => import("/app/template1/pages/checkout/success.vue")
  },
  {
    name: "checkout-success___en",
    path: "/checkout/success",
    component: () => import("/app/template1/pages/checkout/success.vue")
  },
  {
    name: "coming-soon___es",
    path: "/es/coming-soon",
    component: () => import("/app/template1/pages/coming-soon.vue")
  },
  {
    name: "coming-soon___en",
    path: "/coming-soon",
    component: () => import("/app/template1/pages/coming-soon.vue")
  },
  {
    name: "contact-us___es",
    path: "/es/contact-us",
    component: () => import("/app/template1/pages/contact-us.vue")
  },
  {
    name: "contact-us___en",
    path: "/contact-us",
    component: () => import("/app/template1/pages/contact-us.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq",
    component: () => import("/app/template1/pages/faq.vue")
  },
  {
    name: "faq___en",
    path: "/faq",
    component: () => import("/app/template1/pages/faq.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/template1/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/template1/pages/index.vue")
  },
  {
    name: "invoices___es",
    path: "/es/invoices",
    component: () => import("/app/template1/pages/invoices/index.vue")
  },
  {
    name: "invoices___en",
    path: "/invoices",
    component: () => import("/app/template1/pages/invoices/index.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/app/template1/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/app/template1/pages/privacy-policy.vue")
  },
  {
    name: "search-searchText___es",
    path: "/es/search/:searchText()",
    component: () => import("/app/template1/pages/search/[searchText]/index.vue")
  },
  {
    name: "search-searchText___en",
    path: "/search/:searchText()",
    component: () => import("/app/template1/pages/search/[searchText]/index.vue")
  },
  {
    name: "terms-and-conditions___es",
    path: "/es/terms-and-conditions",
    component: () => import("/app/template1/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/terms-and-conditions",
    component: () => import("/app/template1/pages/terms-and-conditions.vue")
  },
  {
    name: component_45stubjXzIzd4uHTMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubjXzIzd4uHT
  }
]